<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Convert Zilog Z80 ASM to Intel syntax</h1>
  </b-row>
  <b-row>
  <h2>Here paste the Z80 ASM</h2>
  </b-row>
  <b-row>
      <b-form-textarea id="textarea1"
                     v-model="text"
                     placeholder="Enter something, or drag text file here"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    </b-row>
  <b-row>
  <h2>Here is the converted ASM</h2>
  </b-row>
    <b-row>
      <div class="sourceout">{{textout}}</div>
    <b-form-textarea id="textarea2"
                     readonly
                     v-model="textout"
                     :rows="10"
                     :max-rows="15">
    </b-form-textarea>
    </b-row>
</b-container>
</template>

<script>
import convert from '../utils/convert.js';
import transZ2I from '../utils/z2i.js';

var doDrag = function (_this) {
  var holder = document.getElementById('textarea1')

  holder.ondragover = function () {
    this.className = 'form-control';
    return false;
  };
  holder.onmouseleave = function () {
    this.className = 'form-control';
    return false;
  };
  holder.ondrop = function (e) {
    this.className = 'form-control';
    e.preventDefault();

    var file = e.dataTransfer.files[0]
    var reader = new FileReader();
    reader.onload = function (event) {
      _this.text = event.target.result;
    };
    reader.readAsText(file);

    return false;
  };
}

export default {
  name: 'z2i',
  data () {
    return {
      text: '',
      position: 24
    }
  },
  computed: {
    textout: {
      get () {
        return convert(this.text, transZ2I);
      },
      set () { return }
    }
  },
  mounted () {
    doDrag(this)
  }
}
</script>

<style>
textarea {font-family: monospace !important;}
</style>
